<template>
  <div :class="{banner: banner}">
    <transition>
      <div class="video-wrapper" v-show="videoLoaded">
        <video :class="{'video-js': !chromeless}" :loop="loop" :autoplay="(autoplay) ? '' : null" :controls="(!chromeless) ? '' : null" preload="none" :poster="(!chromeless) ? media.poster : null" ref="video">
          <source :src="media.dash" type="application/dash+xml" v-if="media.dash"></source>
          <source :src="media.hls" type="application/x-mpegurl" v-if="media.hls"></source>
          <source :src="media.mp4" type="video/mp4" v-if="media.mp4"></source>
          <track kind="captions" :src="media.cc" srclang="en" label="English" v-if="media.cc">
        </video>
      </div>
    </transition>
  </div>
</template>

<script>

  import 'npm/video.js/dist/video-js.css'
  import '@/styles/video-js.scss'

  import videojs from "video.js"
  import "videojs-contrib-dash"
  import "videojs-contrib-hls"

  // Turn off console debugging
  videojs.Html5DashJS.hook('beforeinitialize', (player, mediaPlayer) => {
    mediaPlayer.getDebug().setLogToBrowserConsole(false)
  })

  export default {
    name: 'videoJs',
    props: {
      media: {
        type: Object,
        required: true,
        default () {
          return {}
        }
      },
      autoplay: {
        type: Boolean,
        default: false
      },
      muted: {
        type: Boolean,
        default: false
      },
      chromeless: {
        type: Boolean,
        default: false
      },
      banner: {
        type: Boolean,
        default: false
      },
      loop: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        player: null,
        videoLoaded: false
      }
    },
    mounted () {
      const videoLoaded = () => {
        if(!this.videoLoaded) {
          this.videoLoaded = true
          this.$emit("loadeddata")
        }
      }

      this.player = videojs(this.$refs.video, {
        fluid: true,
        muted: this.muted,
        inactivityTimeout: 750
      })

      $(this.$refs.video).one("loadeddata", videoLoaded)
      setTimeout(videoLoaded, 1000)

    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

  .video-wrapper {
    &.v-enter-active,
    &.v-leave-active {
      transition: opacity .5s;
    }
    &.v-enter,
    &.v-leave-to {
      opacity:0;
    }
  }

  .banner {
    @include position(absolute, 0 0 0 0);
    z-index:-1;
    video {
      @include position(absolute, 50% null null 50%);
      max-width: none; max-height: 100%; min-width: 100%; min-height: 100%; object-fit:cover; transform:translateX(-50%) translateY(-50%); z-index:1;
      @media all and (min-aspect-ratio:16/9) {
        max-height:none; max-width:100%;
      }
    }
    /deep/ > [class^="vjs"] {
      @include position(absolute, 0 0 0 0);
      @include size(auto auto);
      padding:0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/video-js.vue